<h1 ev-dialog-title>Voice Command</h1>

<div ev-dialog-content class="scrollable" data-testid="vc-listen-container">
  <div class="voice-listen-content">

    <div class="voice-listen-panel">

      <div class="voice-listen-stage" aria-hidden="true">
        <span class="voice-listen-ring voice-listen-ring--1"></span>
        <span class="voice-listen-ring voice-listen-ring--2"></span>
        <span class="voice-listen-ring voice-listen-ring--3"></span>

        <div class="voice-listen-halo"></div>

        <div class="voice-listen-orb">
          <svg class="voice-listen-mic" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
            <rect x="22" y="8" width="20" height="30" rx="10" />
            <path d="M14 29 C14 42 22 50 32 50 C42 50 50 42 50 29" />
            <path d="M32 50 L32 58" />
            <path d="M23 58 L41 58" />
          </svg>
        </div>
      </div>

      <div class="voice-listen-text" aria-live="polite">
        @if (recognizedCommand()) {
          <p>{{ recognizedCommand().sentences }}</p>
        }
      </div>

      <div class="voice-listen-progress" aria-hidden="true">
        <span class="voice-listen-progress__fill"></span>
      </div>
    </div>

  </div>
</div>
